import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Homepage from "./pages/homepage";
import ContactPage from "./pages/contact";
import FeaturedWorkPage from "./pages/featuredWork";
import OurStoryPage from "./pages/ourStory";
import Header from "./components/navigation/header";
import IntroVideo from "./components/intro/introVideo";
import { ScrollProvider } from "./context/scrollContext";
import Ursula22 from "./pages/featuredWorkDetails/22Ursula";
import Madonna1 from "./pages/featuredWorkDetails/1Madonna";
import Sutton42A from "./pages/featuredWorkDetails/42ASutton";
import Sutton42 from "./pages/featuredWorkDetails/42Sutton";
function App() {
  const [showVideo, setShowVideo] = useState(false);

  // useEffect(() => {
  //   const navType = performance.getEntriesByType("navigation")[0]?.type;
  //   if (navType === "reload") {
  //     setShowVideo(true);
  //   }
  // }, []);

  useEffect(() => {
    const isFromExternalSite =
      document.referrer &&
      new URL(document.referrer).origin !== window.location.origin;

    const isDirectAccess = document.referrer === "";

    if (isFromExternalSite || isDirectAccess) {
      setShowVideo(true);
    }
  }, []);
  const handleVideoEnd = () => setShowVideo(false);

  return (
    <div className="App">
      {showVideo ? (
        <IntroVideo onVideoEnd={handleVideoEnd} />
      ) : (
        <ScrollProvider>
          <Router>
            <Header />
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/featured-work" element={<FeaturedWorkPage />} />
              <Route
                path="/featured-work/22-Ursula-Street-Winston-Hills"
                element={<Ursula22 />}
              />
              <Route
                path="/featured-work/1-Madonna-Street-Winston-Hills"
                element={<Madonna1 />}
              />
              <Route
                path="/featured-work/42A-Sutton-Street-Blacktown"
                element={<Sutton42A />}
              />
              <Route
                path="/featured-work/42-Sutton-Street-Blacktown"
                element={<Sutton42 />}
              />
              <Route path="/our-story" element={<OurStoryPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Router>
        </ScrollProvider>
      )}
    </div>
  );
}

export default App;
